<template>
    <div style="padding: 15px;height: 100vh">
        <div class="app-content">
            <a-card  title="สถานที่ที่บันทึก">
              <template v-if="!business" #extra>
                  <a-space>
                      <a-button style="display: flex" type="primary" size="large" @click="showDrawer">
                        <template #icon><span class="material-symbols-outlined">Add</span></template>
                         เพิ่มสถานที่ใหม่
                      </a-button>
                  </a-space>
              </template>
              <div style="display: flex; justify-content: space-between; align-items: center;">
                    <div style="display: flex; align-items: center;">
                          <a-input v-model:value="search" placeholder="ค้นหาสถานที่" style="width: 200px;" />
                          <a-button type="primary" style="margin-right: 8px;" @click="fetchData">ค้นหา</a-button>
                          <a-select v-model:value="company" placeholder="บริษัท" style="width: 200px; margin-right: 8px;"   show-search :options="companyOptions" :filter-option="filterOption">
                          <a-select-option v-for="c in companies" :key="c.id" :value="c.id">{{ c.fullname }}</a-select-option>
                          </a-select>
                          <a-button style="margin-left: 8px;" @click="clearFilter">CLEAR</a-button>
                    </div>
              </div>
              <br>
              <a-table :columns="columns" :data-source="filteredData" bordered size="small" :scroll="{ x: 'calc(100px + 50%)', y: '100%' }">
                  <template #bodyCell="{ column, record }">
                      <template v-if="column.key === 'google_map'">
                          <a :href="record.google_map" target="_blank">{{ record.google_map }}</a>
                      </template>
                      <template v-else-if="column.key === 'id'">
                        <div>
                            <a @click="edit(record)"><span style="font-size: 14px"
                                    class="material-symbols-outlined">drive_file_rename_outline</span></a>
                            <a-divider type="vertical"></a-divider>
                            <a @click="remove(record)"><span style="font-size: 14px"
                                    class="material-symbols-outlined">delete</span></a>
                        </div>
                      </template>
                      <template v-else-if="column.key === 'client_id'">
                        {{ companies.find((item)=>item.id == record.client_id)?.fullname }}
                      </template>
                      <template v-else style="display: inline-block; max-width: 150px; white-space: normal; word-wrap: break-word; overflow: visible;">
                          {{ record[column.key] }}
                      </template>
                  </template>
              </a-table>
            </a-card>
            <a-drawer v-model:visible="visible" title="เพิ่มสถานที่" @ok="handleOk" :footer="null">
                <a-form :model="form" layout="vertical" @finish="handleOk">
                  <a-row>
                    <a-col>
                      <a-form-item label="ประเภทของสถานที่" name="place_type_id" >
                        <div style="display: flex; align-items: center;">
                            <a-radio-group 
                                v-model:value="form.place_type_id"
                                :options="placeType?.map(option => ({ label: option.name, value: option.id }))"
                            />
                        </div>
                      </a-form-item>
                      <a-form-item v-if="form.place_type_id != 3" label="บริษัท" name="client_id" :rules="[{ required: true, message: 'กรุณาเลือกบริษัท' }]">
                        <a-select v-model:value="form.client_id" placeholder="เลือกบริษัท">
                          <a-select-option v-for="c in companies" :key="c.id" :value="c.id">{{ c.fullname }}</a-select-option>
                        </a-select>
                      </a-form-item>
                      <a-form-item :label="form.place_type_id == 2 ?'ชื่อสาขา':'ชื่อสถานที่'" name="name" :rules="[{ required: true, message: 'กรุณากรอกชื่อสถานที่' }]">
                        <a-input v-model:value="form.name" :placeholder="form.place_type_id == 2 ?'ชื่อสาขา':'ชื่อสถานที่'"/>
                      </a-form-item>
                      <a-form-item label="ที่อยู่" name="address" :rules="[{ required: true, message: 'กรุณากรอกที่อยู่' }]">
                        <a-input v-model:value="form.address" placeholder="ที่อยู่"/>
                      </a-form-item>
                      <a-form-item label="เบอร์โทร" name="phone_no" :rules="[{required: true, validator: validate_phone, trigger: 'change' }]">
                        <a-input v-model:value="form.phone_no" placeholder="เบอร์โทร"/>
                      </a-form-item>
                      <a-form-item label="Google map" name="google_map" :rules="[{ required: true, message: 'กรุณากรอก link google map' }]">
                        <a-input v-model:value="form.google_map" placeholder="Link google map ของสถานที่"/>
                      </a-form-item>
                      <a-form-item label="พิกัด" name="latlng" :rules="[{validator: validate_latlng, trigger: 'change' }]">
                        <a-input v-model:value="form.latlng" placeholder="Latitude and Longitude" />
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <br>
                  <a-row justify="end">
                      <a-col>
                          <a-button html-type="submit" type="primary" size="large"
                              style="margin: 4px;text-align: right">
                              <span class="material-symbols-outlined"
                                  style="font-size: 16px;margin-right: 4px">Save</span>
                              บันทึกข้อมูล
                          </a-button>
                      </a-col>
                  </a-row>
                </a-form>
            </a-drawer>
        </div>
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import ClientService from '../../api/ClientService.';
import PlaceTypeService from '../../api/PlaceTypeService';
import WorkPlaceService from '../../api/WorkPlaceService';
import { validatePhoneNo, validateLatLng } from '../../components/helpers';
import SystemService from '../../api/SystemService';

export default {
  data() {
    return {
      search: "",
      company: null,
      companies: [],
      columns: [
        { title: "ชื่อสถานที่", dataIndex: "name", key: "name", align: 'center' },
        { title: "ที่อยู่", dataIndex: "address", key: "address", align: 'center' },
        { title: "บริษัท", dataIndex: "client_id", key: "client_id", align: 'center' },
        { title: "เบอร์โทร", dataIndex: "phone_no", key: "phone_no", align: 'center' },
        { title: "Google map", dataIndex: "google_map", key: "google_map", align: 'center' },
        { title: "พิกัด", dataIndex: "latlng", key: "latlng", align: 'center' },
        { title: "ตัวเลือก", key: "id", align: 'center' },
      ],
      data: [],
      visible: false,
      loading: false,
      editing: false,
      form: {
        client_id: null,
        name: "",
        address: "",
        phone_no: "",
        google_map: "",
        latlng: "",
      },
      placeType: [],
    };
  },
  computed: {
    filteredData(){      
      return this.data.filter((item)=>{
        const searchInputLower = this.search ? this.search.toLowerCase() : "";
        const filterName = !this.search || (item.name && item.name.toLowerCase().includes(searchInputLower))
        const filterClientCompany = this.company ? this.company == item.client_id : true;
        return filterName && filterClientCompany;
      });
    }, 
    companyOptions() {
      return this.companies.map(c => ({
      value: c.id,
      label: c.fullname
    }));
  }
  },
  methods: {
    validate_phone: validatePhoneNo,
    validate_latlng: validateLatLng,

    filterOption(input, option) {
      return option.label.toLowerCase().includes(input.toLowerCase());
    },
    async fetchData() {
      // TODO: fetch workplace data from API
      this.placeType = await PlaceTypeService.getAll();
      this.companies = await ClientService.getClientByCompany();
      this.data = await WorkPlaceService.getAllByCompany();
    },
    clearFilter() {
      this.search = "";
      this.company = null;
      this.fetchData();
    },
    showDrawer() {
      this.visible = true;
      this.editing = false;
      this.form = {
        place_type_id: 1,
        client_id: null,
        name: "",
        address: "",
        phone_no: "",
        google_map: "",
        latlng: "",
      };
    },
    async handleOk() {
      this.loading = true;
      // TODO: save form data to API
      if(this.form.latlng) {
        const [lat, lng] = this.form.latlng.split(',');
        this.form.lat = lat?.trim();
        this.form.lng = lng?.trim();
        delete this.form.latlng;  
      }
      if(this.editing == true){
        // edit mode
        try{
          if(this.form.place_type_id == 2) {
            const id = this.form.branch_id;
            delete this.form.branch_id;
            delete this.form.place_type_id;
            this.data = this.data.map((item) => (item.id === id ? this.form : item));
            await SystemService.update_all('ClientBranch', { data: this.form }, id);
          }else{
            this.data = this.data.map((item) => (item.id === this.form.id ? this.form : item));
            await WorkPlaceService.update(this.form, this.form.id);
          }
          Swal.fire(
              'แก้ไขข้อมูลเรียบร้อย!',
              'ข้อมูลของคุณถูกแก้ไขแล้ว',
              'success'
          )
        }catch(err){
          console.log(err);
        }
      } else {
        // add mode
        try{
          if(this.form.place_type_id == 2) {
            delete this.form.place_type_id;
            this.form.company_id = JSON.parse(localStorage.getItem("companyData")).id;
            await SystemService.create_all('ClientBranch', { data: [this.form] });
            delete this.form.company_id;
          }else{
            await WorkPlaceService.create(this.form);
          }
          Swal.fire(
              'เพิ่มข้อมูลเรียบร้อย!',
              'ข้อมูลของคุณถูกเพิ่มแล้ว',
              'success'
          )
        }catch(err){
          console.log(err);
        }
      }
      setTimeout(() => {
        this.loading = false;
        this.visible = false;
        this.fetchData();
      }, 1000);
    },
    edit(record) {
      this.visible = true;
      this.editing = true;
      this.form = { ...record};
    },
    async remove(record) {
      // TODO: remove from API
      console.log("record", record);
       Swal.fire({
              title: `คุณต้องการลบข้อมูลนี้ใช่หรือไม่? [สถานที่ ID: ${record.place_type_id == 2 ? record.branch_id : record.id}]`,
              text: "คุณจะไม่สามารถกู้คืนข้อมูลนี้ได้หากลบแล้ว!",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "ใช่, ลบข้อมูลนี้!",
              cancelButtonText: "ยกเลิก",
          }).then(async (result) => {
              if (result.isConfirmed) {
                  try{
                    if(record.place_type_id == 2) {
                      await SystemService.delete_all('ClientBranch', record.branch_id);
                    }else{
                      await WorkPlaceService.delete(record.id);
                    }
                    Swal.fire(
                        'ลบข้อมูลเรียบร้อย!',
                        'ข้อมูลของคุณถูกลบแล้ว',
                        'success'
                    )
                  }catch(err){
                    console.log(err);
                  }
                  this.fetchData();
              }
          });
    },
  },
  async mounted() {
    await this.fetchData();
  },
};
</script>